import { handleResolveFlaggedStudy } from '@/entities/study';
import { useState } from 'react';
import type { UndoMarkAddressedProps } from './undoMarkAddressed';

/**
 * Backs the undo control that reverses ignoring a flagged study. Tracks a loading flag around a call to handleResolveFlaggedStudy for the given study with the ignore option turned off.
 *
 * @param studyId - Identifier of the study whose flag is being restored.
 * @returns The loading flag and the undo click handler.
 */
export const useUndoMarkAddressed = ({ studyId }: UndoMarkAddressedProps) => {
  const [loading, setLoading] = useState(false);
  /**
   * Reverses ignoring the flagged study when the undo control is clicked. Raises the loading flag, calls handleResolveFlaggedStudy for the study with the ignore option off, logs any failure and clears loading in a finally block.
   *
   * @returns Resolves once the undo request has finished or failed.
   */
  const onClickUndo = async () => {
    try {
      setLoading(true);
      await handleResolveFlaggedStudy(studyId, true, false);
    } catch (error) {
      console.log('Failed to undo skip flagged', error);
    } finally {
      setLoading(false);
    }
  };

  return { loading, onClickUndo };
};
